import React, { useState, useRef, useEffect } from "react";
import { SearchIcon } from "../../../assets/icons";
import { APIS } from "../../../services/config";
import axiosInstance from "../../../services/axiosInstance";
import axios from "axios";

const Location = (props) => {
  const {
    deviceToken,
    handleNext,
    handleBack,
    prompt,
    value,
    values,
    stateValue,
    localGovernmentValue,
    referrerValue,
    statePrompt,
    localGovtPrompt,
    referrerPrompt,
    onStateChange,
    onChange,
    onLocalGovernmentChange,
    bankNameValue,
    accountNumberValue,
    onReferrerChange,
  } = props;

  const [APIStates, setAPIStates] = useState([]);
  const [APILocalGovernment, setAPILocalGovernment] = useState([]);
  const [APIPartners, setAPIPartners] = useState([]);
  const [stateID, setStateId] = useState("");

  const [countrySearchQuery, setCountrySearchQuery] = useState("");
  const [stateSearchQuery, setStateSearchQuery] = useState("");
  const [localGovernmentSearchQuery, setLocalGovernmentSearchQuery] =
    useState("");
  const [activeDropdown, setActiveDropdown] = useState(null);

  const ref = useRef(null);
  const stateRef = useRef(null);
  const localGovtRef = useRef(null);
  const referrerRef = useRef(null);
  const countryRef = useRef(null);

  console.log("deviceToken in Location component:", deviceToken); // Debugging line
  // Get States
  useEffect(() => {
    const {
      baseUrl,
      getStates: { path },
    } = APIS;

    async function fetchStates() {
      const request = await axiosInstance.get(baseUrl + path);
      const states = request?.data?.data ?? [];
      console.log("states", states);
      setAPIStates(states.filter((state) => Number(state?.countryId) === 38));
    }

    fetchStates();
  }, []);

  // Get LGA — triggered when a state is selected
  useEffect(() => {
    if (stateID) {
      const {
        baseUrl,
        getStatesLGA: { path },
      } = APIS;
      async function fetchLGA() {
        const request = await axiosInstance.get(baseUrl + path, {
          params: { state_id: stateID },
        });
        setAPILocalGovernment(request?.data?.data ?? []);
      }
      fetchLGA();
    }
  }, [stateID]);

  // Get Partners (Referrer)
  useEffect(() => {
    const {
      baseUrl,
      getPartners: { path },
    } = APIS;
    async function fetchPartners() {
      const request = await axiosInstance.get(baseUrl + path);
      const result = request?.data?.data?.scoutPartners;
      setAPIPartners(Array.isArray(result) ? result : []);
    }
    fetchPartners();
  }, []);

  useEffect(() => {
    function handleOuterClick(e) {
      if (
        countryRef.current?.contains(e.target) ||
        stateRef.current?.contains(e.target) ||
        localGovtRef.current?.contains(e.target) ||
        referrerRef.current?.contains(e.target)
      ) {
        return;
      }

      setActiveDropdown(null);
    }
    document.addEventListener("mousedown", handleOuterClick);
    return () => document.removeEventListener("mousedown", handleOuterClick);
  }, []);

  // State search filter
  const filterState = Array.isArray(APIStates)
    ? APIStates.filter((state) =>
        state?.name
          .toString()
          .toLowerCase()
          .includes(stateSearchQuery.toString().toLowerCase())
      )
    : [];

  // LGA search filter
  const filterLocalGovernment = Array.isArray(APILocalGovernment)
    ? APILocalGovernment.filter((local) =>
        local.name
          .toString()
          .toLowerCase()
          .includes(localGovernmentSearchQuery.toString().toLowerCase())
      )
    : [];

  function remove_character(str, char_pos) {
    let part1 = str?.substring(0, char_pos);
    let part2 = str?.substring(char_pos + 1, str.length);
    return part1 + part2;
  }

  // let phoneNumber = remove_character(
  //   JSON.parse(localStorage.getItem("phoneNumber")),
  //   4
  // );

  const formatPhoneNumberWithZero = (rawPhoneNumber) => {
    if (!rawPhoneNumber) return "";

    if (rawPhoneNumber.startsWith("+2340")) {
      return rawPhoneNumber;
    }

    if (rawPhoneNumber.startsWith("+234")) {
      return `+2340${rawPhoneNumber.slice(4)}`;
    }

    return rawPhoneNumber;
  };

  let phoneNumber = formatPhoneNumberWithZero(
    JSON.parse(localStorage.getItem("phoneNumber"))
  );

  let firstName = values?.firstName;
  let lastName = values?.lastName;
  let state = stateValue?.id;
  let localGovernmentArea = localGovernmentValue?.id;
  let scoutPartnerRef = referrerValue?.scoutPartnerRef;
  let bankName = bankNameValue?.name;
  let accountNumber = accountNumberValue;
  let bankCode = bankNameValue?.code;

  const payload = {
    // Required fields
    phoneNumber,
    scoutRef: phoneNumber,
    firstName,
    lastName,
    country: "NG",
    language: "English",
    deviceType: "web",
    deviceToken: deviceToken,

    // Optional fields — only include if data is available
    ...(state && { state }),
    ...(localGovernmentArea && { localGovernmentArea }),
    ...(scoutPartnerRef && { scoutPartnerRef }),
    ...(bankName && { bankName }),
    ...(accountNumber && { accountNumber }),
    ...(bankCode && { bankCode }),
  };

  const confirmLocation = async (e) => {
    e.preventDefault();
    const {
      baseUrl,
      createScout: { path },
    } = APIS;
    const request = await axiosInstance.post(baseUrl + path, payload);
    console.log("request", request);
    if (request.data.statusCode === 201) {
      handleNext();
    } else {
      alert(request.data.text);
    }
  };
  const previousStep = () => {
    handleBack();
  };

  const isFormComplete =
    value &&
    stateValue &&
    localGovernmentValue &&
    referrerValue &&
    values?.firstName &&
    values?.lastName;

  console.log("stateValue", stateValue);

  return (
    <>
      <div className="section-in-base background-color-3">
        <div className="container-1140">
          <div className="flex-justify-center">
            <a href="/" className="w-inline-block">
              <img
                src="https://assets.website-files.com/602cf98191f0281f4b6d6db3/602d079c71c9d0b8923420d7_Group%203.svg"
                loading="lazy"
                alt=""
                className="versus-logo"
              />
            </a>
          </div>
          <div className="flex-justify-center margin-top-10">
            <div className="progress-bar active"></div>
            <div className="progress-bar active"></div>
            <div className="progress-bar"></div>
            <div className="progress-bar"></div>
          </div>
          <div className="flex-justify-center">
            <div className="margin-top-40 margin-bottom-40 max-width-medium">
              <div className="w-form">
                <form id="email-form" name="email-form" data-name="Email Form">
                  <h1 className="text-color-4 text-align-center">
                    Just a few more things
                  </h1>
                  <p className="text-color-2 text-align-center">
                    We need this information to send you relevant surveys
                  </p>
                  <div className="margin-top-10 grid-2-columns">
                    {/* Country Dropdown */}
                    <div
                      ref={countryRef}
                      data-hover=""
                      data-delay="0"
                      className="form-input width-full w-dropdown"
                    >
                      <div
                        className="text-color-4 padding-0 width-full w-dropdown-toggle"
                        id="w-dropdown-toggle-0"
                        aria-controls="w-dropdown-list-0"
                        aria-haspopup="menu"
                        aria-expanded="false"
                        onClick={() =>
                          setActiveDropdown(
                            activeDropdown === "country" ? null : "country"
                          )
                        }
                      >
                        <div className="margin-0 margin-top-1 w-icon-dropdown-toggle"></div>
                        <div>{value ? "Nigeria" : prompt}</div>
                      </div>
                      {activeDropdown === "country" ? (
                        <nav className="background-color-white rounded-large mobile-fixed-bottom mobile-border-bottom-rounded-none dropdown-list w-dropdown-list w--open">
                          <div className="padding-4 background-color-white sticky-top-0 rounded-large z-10 border-bottom-1px bottom-rounded-none">
                            <div className="relative">
                              <input
                                style={{ color: "black" }}
                                type="tel"
                                className="form-input light width-64 padding-left-24 margin-0 mobile-width-full width-full w-input"
                                placeholder="Search countries"
                                value={countrySearchQuery}
                                onChange={(e) =>
                                  setCountrySearchQuery(e.target.value)
                                }
                              />
                              <SearchIcon />
                            </div>
                          </div>
                          <>
                            <a
                              style={{ cursor: "pointer" }}
                              className="padding-4 w-dropdown-link"
                              href="#!"
                              onClick={() => {
                                onChange("Nigeria");
                                setActiveDropdown(null);
                              }}
                            >
                              Nigeria
                            </a>
                          </>
                        </nav>
                      ) : null}
                    </div>

                    {/* State Dropdown */}
                    <div
                      ref={stateRef}
                      data-hover=""
                      data-delay="0"
                      className="form-input width-full w-dropdown"
                    >
                      <div
                        className="text-color-4 padding-0 width-full w-dropdown-toggle"
                        id="w-dropdown-toggle-1"
                        aria-controls="w-dropdown-list-1"
                        aria-haspopup="menu"
                        aria-expanded="false"
                        role="button"
                        tabIndex="0"
                        onClick={() =>
                          setActiveDropdown(
                            activeDropdown === "state" ? null : "state"
                          )
                        }
                      >
                        <div className="margin-0 margin-top-1 w-icon-dropdown-toggle"></div>
                        <div>{stateValue ? stateValue.name : statePrompt}</div>
                      </div>
                      <nav
                        className={`background-color-white rounded-large mobile-fixed-bottom mobile-border-bottom-rounded-none dropdown-list w-dropdown-list ${
                          activeDropdown === "state" ? "w--open" : null
                        }`}
                        id="w-dropdown-list-1"
                      >
                        <div className="padding-4 background-color-white sticky-top-0 rounded-large z-10 border-bottom-1px bottom-rounded-none">
                          <div className="relative">
                            <input
                              style={{ color: "black" }}
                              type="tel"
                              className="form-input light width-64 padding-left-24 margin-0 mobile-width-full width-full w-input"
                              placeholder="Search states"
                              onChange={(e) =>
                                setStateSearchQuery(e.target.value)
                              }
                              onClick={(e) => e.stopPropagation()}
                            />
                            <SearchIcon />
                          </div>
                        </div>
                        <>
                          {filterState.map((state) => (
                            <a
                              href="#!"
                              style={{ cursor: "pointer" }}
                              className="padding-4 w-dropdown-link"
                              onClick={() => {
                                onStateChange(state);
                                setActiveDropdown(null);
                                setStateId(state?.id);
                                // Reset LGA when state changes
                                setAPILocalGovernment([]);
                              }}
                              key={state?.id}
                            >
                              {state.name}
                            </a>
                          ))}
                        </>
                      </nav>
                    </div>

                    {/* LGA Dropdown */}
                    <div
                      ref={localGovtRef}
                      data-hover=""
                      data-delay="0"
                      id="w-node-bd8d7202-dbc4-567e-16d7-f8ba354f72fd-f7d0c2fd"
                      className="form-input width-full w-dropdown"
                    >
                      <div
                        className="text-color-4 padding-0 width-full w-dropdown-toggle"
                        id="w-dropdown-toggle-2"
                        aria-controls="w-dropdown-list-2"
                        aria-haspopup="menu"
                        aria-expanded="false"
                        role="button"
                        tabIndex="0"
                        onClick={() =>
                          setActiveDropdown(
                            activeDropdown === "localGovtArea"
                              ? null
                              : "localGovtArea"
                          )
                        }
                      >
                        <div className="margin-0 margin-top-1 w-icon-dropdown-toggle"></div>
                        <div>
                          {localGovernmentValue
                            ? localGovernmentValue.name
                            : localGovtPrompt}
                        </div>
                      </div>
                      <nav
                        className={`background-color-white rounded-large mobile-fixed-bottom mobile-border-bottom-rounded-none dropdown-list w-dropdown-list ${
                          activeDropdown === "localGovtArea" ? "w--open" : null
                        }`}
                        id="w-dropdown-list-2"
                      >
                        <div className="padding-4 background-color-white sticky-top-0 rounded-large z-10 border-bottom-1px bottom-rounded-none">
                          <div className="relative">
                            <input
                              style={{ color: "black" }}
                              type="tel"
                              className="form-input light width-64 padding-left-24 margin-0 mobile-width-full width-full w-input"
                              placeholder="Search local government areas"
                              id="Phone-2"
                              onChange={(e) =>
                                setLocalGovernmentSearchQuery(e.target.value)
                              }
                              onClick={(e) => e.stopPropagation()}
                            />
                            <SearchIcon />
                          </div>
                        </div>
                        <>
                          {filterLocalGovernment.map((local) => (
                            <a
                              href="#!"
                              style={{ cursor: "pointer" }}
                              className="padding-4 w-dropdown-link"
                              onClick={() => {
                                onLocalGovernmentChange(local);
                                setActiveDropdown(null);
                              }}
                              key={local?.id}
                            >
                              {local.name}
                            </a>
                          ))}
                        </>
                      </nav>
                    </div>

                    {/* Referrer Dropdown */}
                    <div
                      ref={referrerRef}
                      data-hover=""
                      data-delay="0"
                      id="w-node-_3b764474-ee0e-0ea8-a226-55f5313c3c7c-f7d0c2fd"
                      className="form-input width-full w-dropdown"
                      onClick={() =>
                        setActiveDropdown(
                          activeDropdown === "referrer" ? null : "referrer"
                        )
                      }
                    >
                      <div
                        className="text-color-4 padding-0 width-full w-dropdown-toggle"
                        id="w-dropdown-toggle-3"
                        aria-controls="w-dropdown-list-3"
                        aria-haspopup="menu"
                        aria-expanded="false"
                        role="button"
                        tabIndex="0"
                      >
                        <div className="margin-0 margin-top-1 w-icon-dropdown-toggle"></div>
                        <div>
                          {referrerValue ? referrerValue.name : referrerPrompt}
                        </div>
                      </div>
                      <nav
                        className={`background-color-white rounded-large mobile-fixed-bottom mobile-border-bottom-rounded-none dropdown-list w-dropdown-list ${
                          activeDropdown === "referrer" ? "w--open" : null
                        }`}
                        id="w-dropdown-list-3"
                        aria-labelledby="w-dropdown-toggle-3"
                      >
                        <>
                          {Array.isArray(APIPartners) &&
                            APIPartners.map((partner) => (
                              <a
                                href="#!"
                                style={{ cursor: "pointer" }}
                                className="padding-4 w-dropdown-link"
                                onClick={() => {
                                  onReferrerChange(partner);
                                  setActiveDropdown(null);
                                }}
                                key={partner?.id}
                              >
                                {partner.name}
                              </a>
                            ))}
                        </>
                      </nav>
                    </div>
                  </div>

                  <div className="margin-top-6 padding-top-6 border-top-2px flex-space-between flex-align-baseline">
                    <button
                      className="button-secondary w-button"
                      onClick={previousStep}
                    >
                      Back
                    </button>
                    <button
                      disabled={!isFormComplete}
                      onClick={confirmLocation}
                      className="button-secondary margin-top-6 w-button"
                    >
                      Continue
                    </button>
                  </div>
                </form>
                <div className="background-color-transparent padding-0 w-form-done">
                  <p className="margin-top-10 text-color-2">
                    Didn't get a code?{" "}
                    <a href="#!" className="text-color-4">
                      Resend it
                    </a>
                  </p>
                </div>
                <div className="w-form-fail">
                  <div>
                    Oops! Something went wrong while submitting the form.
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex-justify-center">
            <a
              href="https://doc.versus.africa/versus/terms-and-conditions-versus-scouts"
              target="_blank"
              rel="noreferrer"
              className="text-color-4 padding-2"
            >
              Terms
            </a>
            <a
              href="https://doc.versus.africa/versus/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className="text-color-4 padding-2"
            >
              Privacy
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default Location;
